var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 127.717,
    height: 163.479,
    viewBox: "0 0 127.717 163.479",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.56,
    y1: 2.476,
    x2: 1.707,
    y2: 1.77,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#f7a63b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#f3d792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#bde1e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#8ac2cb"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    "data-name": "Path 1843",
    d: "M734.091,368.9h-6.386V356.124h6.386a6.386,6.386,0,0,0,0-12.772h-6.386v-5.109a31.984,31.984,0,0,0-22.216-30.416L695.24,284.586a6.393,6.393,0,0,0-5.85-3.816H651.075a6.393,6.393,0,0,0-5.85,3.816l-10.249,23.241a31.964,31.964,0,0,0-22.217,30.416v48.533a31.984,31.984,0,0,0,22.217,30.416l10.249,23.241a6.393,6.393,0,0,0,5.85,3.816H689.39a6.393,6.393,0,0,0,5.85-3.816l10.249-23.241a31.964,31.964,0,0,0,22.216-30.416v-5.109h6.386a6.386,6.386,0,0,0,0-12.772Zm-78.869-75.369h29.99l5.629,12.772H649.577l5.629-12.772Zm29.99,137.951h-29.99l-5.629-12.772h41.264l-5.629,12.772Zm29.706-44.7a19.178,19.178,0,0,1-19.158,19.158H644.673a19.178,19.178,0,0,1-19.158-19.158V368.9h19.158a6.384,6.384,0,0,0,5.708-3.532l7.064-14.128,19.836,39.671a6.378,6.378,0,0,0,11.416,0L699.7,368.9h15.216v17.88Zm0-30.652H695.76a6.384,6.384,0,0,0-5.708,3.532l-7.064,14.128-19.836-39.671a6.378,6.378,0,0,0-11.416,0l-11.006,22.012H625.516V338.243a19.178,19.178,0,0,1,19.158-19.158h51.087a19.178,19.178,0,0,1,19.158,19.158v17.881Z",
    transform: "translate(-612.76 -280.77)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.562dbc310cbce533b8cab12e00b3f1f2.svg";
export { ForwardRef as ReactComponent };